import React from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';

const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="bd left">
            {props.language.account.accountExtendedProperty.table.name}
          </th>
          <th className="th200 left ">
            {props.language.account.accountExtendedProperty.table.dataType}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.accountExtendedProperty.help.dataType}</span>
            </div>
          </th>
          <th className="th250 left ">
            {props.language.account.accountExtendedProperty.table.owner}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.accountExtendedProperty.help.owner}</span>
            </div>
          </th>
          {props.buttonShow && <th className="th100">{props.language.account.accountExtendedProperty.table.actions}</th>}
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => (
          <tr key={`row-${i}`}>
            <td className={"bd-green"}>{item.name}</td>
            <td>{props.language.account.accountExtendedProperty.table[item.dataType.toLowerCase()]}</td>
            <td>{props.language.account.accountExtendedProperty.table[item.crud.toLowerCase()]}</td>
            {props.buttonShow && (
              <td>
                <div className="button-setting flex justify-center">
                  <div />
                    <div>
                      <a>
                        <span className="hover-title">
                          {props.language.account.accountExtendedProperty.modal.editText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModal}
                          className="fas fa-edit"
                        />{' '}
                      </a>
                      <a>
                        <span className="hover-title">
                          {props.language.account.accountExtendedProperty.modal.buttonDelete}
                        </span>
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModalDelete}
                          className="fas fa-ban"
                        />{' '}
                      </a>
                    </div>
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/account_extended_property/table.jsx